import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import {
    LogoPriveIcon,
    LogoLoungeIcon,
} from '@client/components/shared/SvgIcons';
import { injectConfig, configShape } from '@client/hoc/config';
import A from '@client/components/shared/A';

import styles from './styles.scss';

export const Logo = ({
    onClick,
    config,
    alignBottom = false,
    inline = false,
    dark = false,
}) => {
    const HyperLink = A;
    const LogoIcon = config.isPriveDomain ? LogoPriveIcon : LogoLoungeIcon;

    return (
        <div
            styleName={classNames('wrapper', {
                'align-bottom': alignBottom,
                inline,
            })}
        >
            <HyperLink onClick={onClick} to="/event">
                <LogoIcon styleName="icon" dark={dark} />
            </HyperLink>
        </div>
    );
};

Logo.propTypes = {
    onClick: PropTypes.func,
    config: configShape,
    disableInternalRouting: PropTypes.bool,
    alignBottom: PropTypes.bool,
    inline: PropTypes.bool,
    dark: PropTypes.bool,
};

export const injectStyles = component =>
    CSSModules(component, styles, { allowMultiple: true });

export default compose(
    injectConfig,
    injectStyles,
)(Logo);
